import React, {useContext} from 'react'
import {Route, useNavigate} from "react-router";
import {AppContext} from "../../context/app-context";
import {withAccessControl} from "../ProtectedRoute";
import AccessControlBuilder from "../AccessControlBuilder";
import {Account} from "../../interfaces";

import AdminReports from "../../views/AdminReports";
import AdminBookingsReport from '../../views/admin/AdminBookingsReport/AdminBookingsReport';
import AdminLocationsReport from "../../views/admin/AdminLocationsReport/AdminLocationsReport";
import AdminPayoutsReport from "../../views/admin/AdminPayoutsReport/AdminPayoutsReport";
import AdminSpaceUsageReport from "../../views/admin/AdminSpaceUsageReport/AdminSpaceUsageReport";
import LoginAsAccount from "../../views/LoginAsAccount";
import AdminInvoicesReportRedesign from "../../views/admin/AdminInvoicesReport/AdminInvoicesReport";
import ExternalInvoice from '../../views/errors/ExternalInvoice';
import AdminAccountReport from "../../views/admin-accounts-report/AdminAccountReport";
import AdminInterchangesReport from "../../views/admin/AdminInterchangesReport/AdminInterchangesReport";

const adminAuthorization = new AccessControlBuilder().allowAdmin().build()

const ProtectedAdminReports = withAccessControl(AdminReports, adminAuthorization)
const ProtectedAdminBookingsReport = withAccessControl(AdminBookingsReport, adminAuthorization)
const ProtectedAdminLocationsReport = withAccessControl(AdminLocationsReport, adminAuthorization)
const ProtectedAdminInvoicesReportRedesign = withAccessControl(AdminInvoicesReportRedesign, adminAuthorization)
const ProtectedAdminPayoutsReport = withAccessControl(AdminPayoutsReport, adminAuthorization)
const ProtectedAdminSpaceUsageReport = withAccessControl(AdminSpaceUsageReport, adminAuthorization)
const ProtectedLoginAsAccount = withAccessControl(LoginAsAccount, adminAuthorization)
const ProtectedExternalInvoice = withAccessControl(ExternalInvoice, adminAuthorization)
const ProtectedAdminAccountReport = withAccessControl(AdminAccountReport, adminAuthorization)
const ProtectedAdminInterchangesReport = withAccessControl(AdminInterchangesReport, adminAuthorization)


const AdminContent = (): React.ReactElement<any>[] => {
  const appContext = useContext(AppContext)
  const {updateUser, logout} = appContext

  const history = useNavigate();

  const updateUserAndRedirect = (user: Account) => {
    updateUser(user, history);
  }

  return [
    <Route path="/admin-reports" key="/admin-reports" element={<ProtectedAdminReports/>}/>,
    <Route path="/admin-accounts" key="/admin-accounts"
           element={<ProtectedAdminAccountReport handleLogout={logout}/>}/>,
    <Route path="/admin-bookings" key="/admin-bookings"
           element={<ProtectedAdminBookingsReport handleLogout={logout}/>}/>,
    <Route path="/admin-locations" key="/admin-locations"
           element={<ProtectedAdminLocationsReport handleLogout={logout}/>}/>,
    <Route path="/admin-invoices" key="/admin-invoices"
           element={<ProtectedAdminInvoicesReportRedesign handleLogout={logout}/>}/>,
    <Route path="/admin-payouts" key="/admin-payouts"
           element={<ProtectedAdminPayoutsReport/>}/>,
    <Route path="/admin-space-usage" key="/admin-space-usage"
           element={<ProtectedAdminSpaceUsageReport/>}/>,
    <Route path="/login-as-account" key="/login-as-account"
           element={<ProtectedLoginAsAccount handleAccountChange={updateUserAndRedirect}/>}/>,
    <Route path="/invoice/:invoiceNumber" key="/invoice" element={<ProtectedExternalInvoice type="overage"/>}/>,
    <Route path="/admin-interchanges" key="/admin-interchanges"
           element={<ProtectedAdminInterchangesReport/>}/>,
  ]
}

export default AdminContent
